<template>
  <div>
    <div
      v-if="invoice"
      class="sale-document-body md__border border-radius bg-color-write p-3 mb-2"
    >
      <div class="sale-document-info">
        <div class="sale-document-description d-flex justify-content-between">
          <div class="info cursor-point" @click.stop="invoiceView">
            <p class="m-0 text-color-primary str-limit-space">
              N° {{ invoice.invoice_number }}
            </p>
            <p class="m-0 font-bold text-color-primary str-limit-space">
              {{ invoice.cliente.nombre_comprador }}
            </p>
          </div>
          <div class="sale-document-number">
            <h5 class="h5 font-bold">
              <FormatAmount :amount="invoice.total" />
            </h5>
            <span class="card-date">{{
              formatFullDate(invoice.emission_date || invoice.created_at)
            }}</span>
          </div>
        </div>
      </div>

      <div
        class="sale-document-actions d-flex justify-content-between align-items-center mt-4"
      >
        <div class="status d-flex">
          <StatusReadDocumentsComponent
            :status="invoice.status"
            typeStatus="short"
          />
          <!-- <div class="next">
            <InvoiceOptionsByStatus
              :status="invoice.status"
              :id="invoice.id"
              :is_paid="invoice.is_paid"
              @goPage="goRouter"
              @payLink="getInvoicePaymentLink"
              @onUpdate="onUpdate"
            />
          </div> -->
        </div>
      </div>
      <WrapperPaymentLink
        :paymentLink="paymentLink"
        :showDialog.sync="showDialogPayLink"
        @onDialogClose="onDialogPayLinkClose"
      />
    </div>
    <PaymentUploadDocument
      :visible.sync="showEnablePaylink"
      @onClose="onClosePaymentUpDoc"
      v-if="showEnablePaylink"
    />
  </div>
</template>

<script>
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import WrapperPaymentLink from "../../../components/WrapperPaymentLink";
import FormatAmount from "@/components/General/FormatAmount";
import PaymentUploadDocument from "../../payments/components/PaymentUploadDocument";
import paymentService from "../../payments/services/paymentService";
// import InvoiceOptionsByStatus from "./InvoiceOptionsByStatus.vue";

export default {
  name: "InvoiceApiCardComponent",
  data() {
    return {
      showDialogPayLink: false,
      paymentLink: null,
      //  icoWooCommerce,
      showEnablePaylink: false
    };
  },
  computed: {
    quote() {
      const { quote } = this.invoice;
      return quote;
    },
    isStatusNuled() {
      return this.invoice.status === "nuled";
    },
    isStatusApproved() {
      return this.invoice.status === "success";
    }
  },
  methods: {
    formatFullDate(date) {
      if (!date) return "";
      const normalized = /^\d{4}-\d{2}-\d{2}$/.test(date) ? date + "T00:00:00" : date;
      const d = new Date(normalized);
      const months = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    invoiceView() {
      this.goRouter("sales.invoices.api.view", {
        id: this.invoice.id
      });
    },
    onDialogPayLinkClose() {
      this.showDialogPayLink = false;
    },
    onClosePaymentUpDoc() {
      this.showEnablePaylink = false;
    },
    onUpdate() {
      this.$emit("onUpdate");
    },
    async getInvoicePaymentLink() {
      try {
        this.$store.dispatch("toggleRequestLoading");

        let response = await paymentService
          .getInvoicePaymentLink({
            invoice_id: this.invoice.id
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, data, upload_docs = false } = response.data;

        if (success) {
          this.showDialogPayLink = true;
          this.paymentLink = data;
        } else if (upload_docs) {
          this.showEnablePaylink = true;
        }
      } catch (error) {
        return false;
      }
      return false;
    }
  },
  components: {
    StatusReadDocumentsComponent,
    WrapperPaymentLink,
    FormatAmount,
    PaymentUploadDocument
    // InvoiceOptionsByStatus
  },
  props: {
    invoice: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
